import { StyledHeading } from "#/atoms";
import styled from "styled-components";

export const StyledSuport = styled.div`
  ${StyledHeading} {
    margin-bottom: 0;
    margin-right: 0;
  }
`;